import React, { useCallback } from "react";

import { ChangeJobStatusButtonModal } from "./../Dialogs";
import { ChangeStatus } from "../../../../components/svg/svgImageList";
import { ChangeJobStatus as PermissionChangeStatus } from "../../../../services/authorization/Permissions";
import Button from "../../../../components/button/Button";
import useThemeService from "../../../../services/theme-service/ThemeService";
import useModal from "../../../../components/dialog/useModal";
import { permissionsService } from "../../../../services/authorization/UserPermissionsService";
import { MultipleJobsActionProps } from "./MultipleJobsActionProps";

export function ChangeJobStatusButton(props: MultipleJobsActionProps) {
  const { themeClass } = useThemeService();

  const { isVisible, toggleModal } = useModal();

  const { jobsStorage } = { ...props };
  const isDisabled = useCallback(
    () =>
      !permissionsService.userHasPermissionTo(PermissionChangeStatus) ||
      !jobsStorage.anyItemsSelected,
    [jobsStorage.anyItemsSelected]
  );

  return (
    <>
      <Button
        icon={{
          svg: ChangeStatus,
          textKey: "jobs.ChangeJobStatusButton.label",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-change-status"]),
        }}
        disabled={isDisabled()}
        onClick={toggleModal}
      />
      <ChangeJobStatusButtonModal
        isVisible={isVisible}
        toggleModal={toggleModal}
        jobsStorage={jobsStorage}
      />
    </>
  );
}
